export default __webpack_public_path__ + "static/media/tokenImageBankzz.99318cba.svg";